export default __webpack_public_path__ + "static/media/FinLab.b4abfead.png";